import React from 'react'
import PropTypes from 'prop-types'
import ReactReveal from 'react-reveal/Reveal'
import './Reveal.styles.css'

const Reveal = ({ effect, collapse, children, ...props }) => (
  <ReactReveal effect={collapse ? null : effect} collapse={collapse} {...props}>
    {children}
  </ReactReveal>
)

export default Reveal

Reveal.defaultProps = {
  effect: 'fadeInUp'
}

Reveal.propTypes = {
  effect: PropTypes.oneOf([
    'fadeIn',
    'fadeInUp',
    'fadeInDown',
    'fadeInRight',
    'fadeInLeft'
  ]),
  when: PropTypes.bool,
  collapse: PropTypes.bool
}
